import InstantServiceReviewForm from "../../components/review-form/instant-service-review-form";

const InstantServiceReviewsPage = () => {
  return <InstantServiceReviewForm />;
};

export default InstantServiceReviewsPage;
